import { chakra, forwardRef, Box as Box$1, useStyleConfig, VisuallyHidden, toCSSVar, Heading as Heading$1, useInterval, VStack, HStack, Center } from '@chakra-ui/react';
import { keyframes, useTheme as useTheme$1 } from '@emotion/react';
import { motion as motion$2 } from '@hover/chakra-theme/foundation';
import { includes, entries, pick, random } from '@hover/utilities';
import { motion as motion$1, AnimatePresence } from 'framer-motion';
import { useMemo, useState, useEffect } from 'react';
import 'ramda/src/omit';
import 'ramda/src/pick';
import '@chakra-ui/system';
import 'ramda/src/has';
import 'tiny-warning';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/join';
import 'ramda/src/identity';
import 'ramda/src/ifElse';
import 'ramda/src/map';
import 'ramda/src/split';
import 'ramda/src/concat';
import 'ramda/src/toLower';
import 'ramda/src/pipe';
import _mergeDeepLeft from 'ramda/src/mergeDeepLeft';
import _mergeLeft from 'ramda/src/mergeLeft';
import { components, foundations } from '@hover/chakra-theme/next';
import { mapResponsive, reduceResponsive } from '@hover/chakra-theme';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var svgElements = ['animate', 'circle', 'clipPath', 'defs', 'desc', 'ellipse', 'feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'metadata', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'symbol', 'text', 'textPath', 'tspan', 'use'];
/**
 * Framer Motion's `motion` factory with types that work properly with system
 * components and returns motion components augmented with system style props
 * when using the shortand for intrinsic HTML elements (e.g: `<motion.div />`)
 *
 * Note that there a couple things to keep in mind when working with motion
 * components:
 *
 * - If you're going to spread external props into the component, make sure to
 *   type the props using `MotionPropsFor` (see example below).
 * - If the root component in your custom component is a `motion()` component,
 *   you must always forward a ref to it with `forwardRef` as Framer uses refs
 *   for some types of motion.
 *
 * @example
 * ```tsx
 * import { forwardRef, motion, MotionPropsFor, Box, BoxProps } from '@hover/blueprint';
 *
 * export interface MyAnimatedComponentProps extends MotionPropsFor<BoxProps> {
 *   isFoo?: boolean;
 * }
 *
 * const MotionBox = motion(Box);
 *
 * export const MyAnimatedComponent = forwardRef<MyAnimatedComponentProps, 'div'>(
 *   ({ isFoo, ...props }) => <MotionBox {...props}>{isFoo ? 'foo' : 'bar'} />
 * )
 * ```
 */
var motion = /*#__PURE__*/function () {
  // I don't think it's really possible to type this stuff properly with Framer
  // Motion types and trying to do so brought TypeScript to its knees for some
  // reason. Even if it didn't I'm not sure it's worth it.
  var cache = /*#__PURE__*/new Map();
  return new Proxy(motion$1, {
    get: function get(_, element) {
      if (includes(svgElements, element)) {
        return motion$1[element];
      }
      if (!cache.has(element)) cache.set(element, motion$1(chakra(element)));

      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return cache.get(element);
    }
  });
}();

var _excluded2 = ["testId"];
var attribute = 'data-testid';
var dataAttribute = function dataAttribute(condition) {
  return condition ? '' : undefined;
};

/**
 * Returns an object containing test ID *attribute* (e.g: `data-testid`)
 *
 * @example
 * const props = { testId: 'foo', bar: 'baz' };
 * <Component {...applyTestId(props)} />
 * // Equivalent
 * <Component data-testid="foo" />
 *
 * @param props - Props object with test ID prop
 *
 * @returns Object with test ID attribute
 */
var applyTestId = function applyTestId(_ref2) {
  var testId = _ref2.testId;
  return _defineProperty({}, attribute, testId);
};

/**
 * Replaces the test ID prop in supplied props object with a test ID *attribute* (e.g: `data-testid`)
 *
 * @example
 * const props = { testId: 'foo', bar: 'baz' };
 * <Component {...withTestId(props)} />
 * // Equivalent
 * <Component data-testid="foo" bar="baz" />
 *
 * @param props - Props object with test ID prop
 *
 * @returns Props object with test ID *attribute* in place of test ID prop
 */
var withTestId = function withTestId(_ref4) {
  var testId = _ref4.testId,
    props = _objectWithoutProperties(_ref4, _excluded2);
  return _objectSpread2(_objectSpread2({}, applyTestId({
    testId: testId
  })), props);
};

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _excluded$3 = ["children"];
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$3);
  return jsx(Box$1, _objectSpread2(_objectSpread2({
    boxSizing: "border-box",
    display: "flex"
  }, withTestId(props)), {}, {
    ref: ref,
    children: children
  }));
});
Box.displayName = 'Box';

var _excluded$2 = ["label", "color", "speed", "size"];
var _templateObject$1;
var durations = {
  500: motion$2.animation.spin[500].duration,
  700: motion$2.animation.spin[700].duration
};
var spin$1 = /*#__PURE__*/keyframes(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteral(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"])));
var Loader$1 = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Loading' : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary.600' : _ref$color,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? 500 : _ref$speed,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var styles = useStyleConfig('Icon', _objectSpread2({
    size: size
  }, props));
  return jsxs(Box, _objectSpread2(_objectSpread2({}, withTestId(props)), {}, {
    alignContent: "center",
    "aria-busy": true,
    color: color,
    justifyContent: "center",
    ref: ref,
    children: [jsx(VisuallyHidden, {
      "aria-live": "polite",
      children: label
    }), jsxs(chakra.svg, {
      animation: "".concat(durations[speed], "s linear 0s infinite normal none running ").concat(spin$1),
      "aria-hidden": "true",
      focusable: "false",
      role: "img",
      sx: styles,
      viewBox: "0 0 512 512",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("path", {
        d: "M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z",
        fill: "currentColor",
        opacity: 0.4
      }), jsx("path", {
        d: "M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z",
        fill: "currentColor"
      })]
    })]
  }));
});

var nextFeatures = ['borders', 'color', 'components', 'fonts', 'sizes', 'space', 'typography'];
var nextFeatureMap = {
  borders: ['radii'],
  color: ['colors'],
  components: ['components'],
  fonts: ['fonts'],
  sizes: ['sizes'],
  space: ['space'],
  typography: ['fontSizes', 'fontWeights', 'lineHeights', 'letterSpacings', 'textStyles']
};
var applyNextTheme = function applyNextTheme(theme, next) {
  if (!next) return theme;

  // We want to do a shallow merge on the components because we don't want to
  // merge the component themes themselves. Any next theme components replace
  // existing component themes entirely.
  var components$1 = next === 'all' || next.includes('components') ? _mergeLeft(components, theme.components) : theme.components;
  if (next === 'all') {
    return _objectSpread2(_objectSpread2({}, _mergeDeepLeft(foundations, theme)), {}, {
      components: components$1
    });
  }
  var features = entries(nextFeatureMap).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return includes(next, key);
  }).flatMap(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      value = _ref4[1];
    return value;
  });
  return _objectSpread2(_objectSpread2({}, _mergeDeepLeft(pick(foundations, features.filter(function (i) {
    return i !== 'components';
  })), theme)), {}, {
    components: components$1
  });
};

var useTheme = function useTheme() {
  return useTheme$1();
};
var useNextTheme = function useNextTheme() {
  var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
  var theme = useTheme$1();
  return useMemo(function () {
    return toCSSVar(applyNextTheme(theme, next));
  }, [next, theme]);
};

var _excluded$1 = ["children", "isDisplay", "isLight", "size", "noMargin", "withCapsize", "mb", "marginBottom"];
var elements = {
  200: 'h6',
  300: 'h5',
  400: 'h4',
  500: 'h3',
  600: 'h2',
  650: 'h2',
  700: 'h1',
  800: 'h1',
  900: 'h1'
};
var Heading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$isDisplay = _ref.isDisplay,
    isDisplay = _ref$isDisplay === void 0 ? false : _ref$isDisplay,
    _ref$isLight = _ref.isLight,
    isLight = _ref$isLight === void 0 ? false : _ref$isLight,
    _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? 600 : _ref$size,
    _ref$noMargin = _ref.noMargin,
    noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin,
    _ref$withCapsize = _ref.withCapsize,
    withCapsize = _ref$withCapsize === void 0 ? false : _ref$withCapsize,
    mb = _ref.mb,
    marginBottom = _ref.marginBottom,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var size = mapResponsive(function (s) {
    return "".concat(s);
  }, sizeProp);
  var largestSize = reduceResponsive(function (acc, value) {
    return value && value > acc ? value : acc;
  }, 200, sizeProp);
  var textStyle = withCapsize ? mapResponsive(function (s) {
    return "heading".concat(s, "WithCapsizeAndMargin");
  }, sizeProp) : undefined;
  var getVariant = function getVariant() {
    if (isDisplay) return 'display';
    if (isLight) return 'light';
    return 'default';
  };
  return jsx(Heading$1, _objectSpread2(_objectSpread2({
    as: elements[largestSize],
    marginTop: "0",
    textStyle: textStyle
  }, withTestId(props)), {}, {
    marginBottom: noMargin ? '0 !important' : marginBottom !== null && marginBottom !== void 0 ? marginBottom : mb,
    ref: ref,
    size: size,
    variant: getVariant(),
    children: children
  }));
});
Heading.displayName = 'Heading';

var _excluded = ["brickDelay", "brickDelayVariation", "brickProps", "captionDuration", "captions", "color", "columns", "label", "rows", "brickSpacing", "speed"];
var _templateObject, _templateObject2;
var MotionHeading = /*#__PURE__*/motion(Heading);
var BRICK_OFFSET = '-200px';
var spin = /*#__PURE__*/keyframes(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(720deg); }\n"])));
var Loader = function Loader(props) {
  return jsxs(chakra.svg, _objectSpread2(_objectSpread2({
    fill: "none",
    viewBox: "0 0 288 288",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [jsx("path", {
      d: "M144 2.99999C144 1.34314 145.344 -0.00327085 147 0.0312428C168.693 0.483233 190.018 5.83256 209.375 15.6951C229.622 26.0118 247.141 40.9742 260.498 59.3589C273.856 77.7436 282.672 99.0285 286.227 121.473C289.625 142.93 288.123 164.864 281.849 185.636C281.37 187.222 279.675 188.083 278.099 187.571L270.11 184.976C268.534 184.464 267.676 182.772 268.151 181.185C273.725 162.576 275.047 142.938 272.004 123.726C268.805 103.526 260.87 84.3692 248.849 67.823C236.827 51.2768 221.06 37.8107 202.837 28.5256C185.506 19.6948 166.421 14.8843 147 14.4347C145.344 14.3964 144 13.0569 144 11.4L144 2.99999Z",
      fill: "currentColor"
    }), jsx("path", {
      d: "M288 144C288 223.529 223.529 288 144 288C64.471 288 0 223.529 0 144C0 64.471 64.471 0 144 0C223.529 0 288 64.471 288 144ZM14.4 144C14.4 215.576 72.4239 273.6 144 273.6C215.576 273.6 273.6 215.576 273.6 144C273.6 72.4239 215.576 14.4 144 14.4C72.4239 14.4 14.4 72.4239 14.4 144Z",
      fill: "currentColor",
      opacity: "0.4"
    })]
  }));
};
var animateBrick = function animateBrick() {
  return keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% { transform: translateY(", ") rotateZ(", "deg); }\n  100% { transform: translateY(0px) rotateZ(0deg);  }\n"])), BRICK_OFFSET, random(90, 0));
};
var ProgressiveLoader = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$brickDelay = _ref.brickDelay,
    brickDelay = _ref$brickDelay === void 0 ? 0.25 : _ref$brickDelay,
    _ref$brickDelayVariat = _ref.brickDelayVariation,
    brickDelayVariation = _ref$brickDelayVariat === void 0 ? 3 : _ref$brickDelayVariat,
    brickProps = _ref.brickProps,
    _ref$captionDuration = _ref.captionDuration,
    captionDuration = _ref$captionDuration === void 0 ? 2000 : _ref$captionDuration,
    captions = _ref.captions,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary.600' : _ref$color,
    _ref$columns = _ref.columns,
    columnsProp = _ref$columns === void 0 ? 3 : _ref$columns,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Loading' : _ref$label,
    _ref$rows = _ref.rows,
    rowsProp = _ref$rows === void 0 ? 6 : _ref$rows,
    _ref$brickSpacing = _ref.brickSpacing,
    spacing = _ref$brickSpacing === void 0 ? '2px' : _ref$brickSpacing,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? 500 : _ref$speed,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    lineHeights = _useTheme.lineHeights;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    captionIndex = _useState2[0],
    setCaptionIndex = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAnimating = _useState4[0],
    setIsAnimating = _useState4[1];
  useInterval(function () {
    if (!captions) return;
    setCaptionIndex(function (i) {
      return i + 1 > captions.length - 1 ? 0 : i + 1;
    });
  }, captionDuration);
  var bricks = useMemo(function () {
    return Array.from({
      length: rowsProp
    }).map(function (_, row) {
      return {
        row: row,
        columns: Array.from({
          length: row === 0 ? columnsProp - 1 : columnsProp
        }, function (__, column) {
          var total = rowsProp * columnsProp - 1;
          var index = row === 0 ? column : row * columnsProp - 1 + column;
          var delay = (total - index) * brickDelay + random(brickDelay * brickDelayVariation, 0, false);
          return {
            column: column,
            index: index,
            animation: "0.5s ease-in ".concat(delay, "s 1 normal both running ").concat(animateBrick())
          };
        })
      };
    });
  }, [brickDelay, brickDelayVariation, columnsProp, rowsProp]);
  useEffect(function () {
    return setIsAnimating(true);
  }, []);
  return jsxs(VStack, _objectSpread2(_objectSpread2({
    "aria-busy": true,
    "aria-label": label,
    "aria-live": "polite",
    color: color,
    ref: ref,
    spacing: "500"
  }, props), {}, {
    children: [jsxs(Box, {
      alignContent: "center",
      justifyContent: "center",
      overflow: "hidden",
      position: "relative",
      role: "progressbar",
      width: {
        base: '600',
        width250: '700'
      },
      children: [jsx(Box, {
        animation: "".concat(durations[speed] * 3, "s linear 0s infinite normal none running ").concat(spin),
        height: "100%",
        width: "100%",
        children: jsx(Loader, {
          animation: "".concat(durations[speed], "s ease-in-out 0s infinite normal none running ").concat(spin),
          width: "100%"
        })
      }), jsx(VStack, {
        clipPath: "circle(calc(50% - 12px) at 50% 50%)",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        overflow: "hidden",
        padding: "27.5%",
        position: "absolute",
        spacing: spacing,
        width: "100%",
        children: bricks.map(function (_ref2) {
          var row = _ref2.row,
            columns = _ref2.columns;
          var r = "row-".concat(row);
          return jsx(HStack, {
            className: r,
            height: "".concat(100 / rowsProp, "%"),
            spacing: spacing,
            transform: "translateX(".concat(row % 2 === 0 ? '7' : '-3', "%)"),
            width: "100%",
            children: columns.map(function (_ref3) {
              var column = _ref3.column,
                animation = _ref3.animation;
              var c = "column-".concat(column);
              return jsx(chakra.div, _objectSpread2({
                animation: isAnimating ? animation : 'none',
                bg: "currentColor",
                borderColor: "currentColor",
                borderRadius: {
                  base: '2px',
                  width250: '200'
                },
                className: "brick ".concat(c),
                flexShrink: 0,
                height: "100%",
                position: "relative",
                transform: "translateY(".concat(BRICK_OFFSET, ")"),
                width: "".concat(100 / columnsProp, "%")
              }, brickProps), c);
            })
          }, r);
        })
      })]
    }), captions && jsx(Center, {
      height: lineHeights[600],
      position: "relative",
      width: "100%",
      children: jsx(AnimatePresence, {
        children: jsx(MotionHeading, {
          animate: {
            opacity: 1,
            y: '0%'
          },
          color: "neutral.700",
          exit: {
            opacity: 0,
            y: '-50%'
          },
          initial: {
            opacity: 0,
            y: '50%'
          },
          position: "absolute",
          size: {
            base: 300,
            width250: 500
          },
          textAlign: "center",
          transition: {
            y: motion$2.framer.firm,
            opacity: {
              duration: 0.1,
              bounce: 0
            }
          },
          width: "100%",
          children: captions[captionIndex]
        }, captionIndex)
      })
    })]
  }));
});

export { Box as B, Heading as H, Loader$1 as L, ProgressiveLoader as P, _objectWithoutProperties as _, _objectSpread2 as a, _taggedTemplateLiteral as b, _defineProperty as c, _slicedToArray as d, _arrayLikeToArray as e, _unsupportedIterableToArray as f, applyNextTheme as g, applyTestId as h, dataAttribute as i, useNextTheme as j, motion as m, nextFeatures as n, useTheme as u, withTestId as w };
